const stuffs = () => {
    $('.stuffs .stuffs-list').on('click', '.item', function(){
        let show = $(this).data('show')
        if(show) {
            $(".stuffs .detail").fadeIn();
            $("html").addClass("overflow-hidden");
        }
    })

    $(".stuffs .detail .close-modal").on("click", function(){
        $("html").removeClass("overflow-hidden");
        $(".stuffs .detail").fadeOut();
    })
}

module.exports = stuffs
